export enum Forms {
  ShipaSupplier = 'ShipaSupplier',
  ShipaGlobalTracking = 'ShipaGlobalTracking',
  SECCallBack = 'SECCallBack',
  SECShort = 'SECShort',
  SECExtraShort = 'SECExtraShort',
  SDBusinessWorkWithUs = 'SDBusinessWorkWithUs',
  SDBusinessCallBack = 'SDBusinessCallBack',
  SDConsumerCallBack = 'SDConsumerCallBack',
  SubmitYourResume = 'SubmitYourResume',
  JoinDeliveryFleet = 'JoinDeliveryFleet',
  SECGetInTouch = 'SECContactUs',
  TrackShipment = 'TrackShipment'
}
